// extracted by mini-css-extract-plugin
export default {"canvas":"CanvasComponent_canvas__Xp583"};